import { render, staticRenderFns } from "./SchoolSystemIconParentDialog.vue?vue&type=template&id=bc3af20e&scoped=true"
import script from "./SchoolSystemIconParentDialog.vue?vue&type=script&lang=js"
export * from "./SchoolSystemIconParentDialog.vue?vue&type=script&lang=js"
import style0 from "./SchoolSystemIconParentDialog.vue?vue&type=style&index=0&id=bc3af20e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3af20e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bc3af20e')) {
      api.createRecord('bc3af20e', component.options)
    } else {
      api.reload('bc3af20e', component.options)
    }
    module.hot.accept("./SchoolSystemIconParentDialog.vue?vue&type=template&id=bc3af20e&scoped=true", function () {
      api.rerender('bc3af20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/master/systemconfig/SchoolSystemIconParentDialog.vue"
export default component.exports